import React from 'react';

const TelemetryPage: React.FC = () => {
    return (
        <div style={{
            minHeight: '100vh',
            background: 'white',
            color: '#4a306d',
            fontFamily: 'Arial, sans-serif'
        }}>
            {/* Hero Section */}
            <section style={{
                textAlign: 'center',
                padding: '0',
                background: 'transparent',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem', width: '100%' }}>
                    {/* Logo */}
                    <div style={{ marginBottom: '2rem' }}>
                        <img
                            src="/tdl-logo.jpg"
                            alt="TDL Coaching & Consulting"
                            style={{
                                height: '100px',
                                maxWidth: '500px',
                                width: 'auto',
                                objectFit: 'contain',
                                borderRadius: '8px'
                            }}
                        />
                    </div>

                    <h1 className="hero-title" style={{
                        color: '#4a306d'
                    }}>
                        Become a Certified Telemetry Technician — 100% Online
                    </h1>
                    <h2 className="hero-subtitle" style={{
                        color: '#6b6b6b'
                    }}>
                        Self-Paced Learning • Weekly Live Zoom Classes • Certificate Included
                    </h2>

                    {/* Two Column Layout for Price and Video */}
                    <div className="hero-grid">
                        {/* Left Column - Price and CTA */}
                        <div style={{ textAlign: 'center' }}>
                            <div style={{
                                fontSize: '2rem',
                                color: '#34a8a8',
                                fontWeight: 'bold',
                                marginBottom: '1rem'
                            }}>
                                Only $59.99
                            </div>
                            <div style={{
                                fontSize: '1rem',
                                color: '#34a8a8',
                                marginBottom: '1.5rem'
                            }}>
                                (Limited Time - Save $40!)
                            </div>
                            <a
                                href="https://www.tdlcoaching.com/challenge-page/cd98d7e4-58c6-4ed8-83f0-2987b1dccaa5?programId=cd98d7e4-58c6-4ed8-83f0-2987b1dccaa5"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    background: '#34a8a8',
                                    color: 'white',
                                    padding: '0.8rem 1.5rem',
                                    textDecoration: 'none',
                                    borderRadius: '50px',
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                    display: 'inline-block',
                                    boxShadow: '0 4px 15px rgba(52, 168, 168, 0.4)',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                ➡️ Enroll Now for $59.99
                            </a>
                            <div style={{
                                marginTop: '1rem',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                color: '#34a8a8'
                            }}>
                                💓 Learn to Read the Heart's Rhythm — From Home
                            </div>
                        </div>

                        {/* Right Column - Video */}
                        <div style={{
                            maxWidth: '100%'
                        }}>
                            <div style={{
                                position: 'relative',
                                paddingBottom: '56.25%',
                                height: 0,
                                overflow: 'hidden',
                                borderRadius: '15px',
                                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
                                background: '#000'
                            }}>
                                <iframe
                                    src="https://www.youtube.com/embed/gSOyXIMJCEA?rel=0&modestbranding=1"
                                    title="Telemetry Training Video"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        borderRadius: '15px',
                                        border: 'none'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Telemetry Section */}
            <section style={{ padding: '4rem 0', background: 'transparent' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <h3 style={{
                        fontSize: '2.5rem',
                        textAlign: 'center',
                        marginBottom: '2rem',
                        color: '#34a8a8'
                    }}>
                        Why Become a Telemetry Technician?
                    </h3>
                    <div style={{
                        background: 'rgba(240, 240, 240, 0.5)',
                        padding: '2rem',
                        borderRadius: '15px',
                        lineHeight: '1.6',
                        marginBottom: '3rem'
                    }}>
                        <p style={{ marginBottom: '1rem' }}>
                            Telemetry Technicians play a crucial role in monitoring patients' cardiac rhythms and arrhythmias,
                            making a great salary while working in a vital sector of the healthcare industry. This is an excellent
                            entry point for anyone looking to build a career in healthcare, with flexible shifts to suit your
                            schedule—whether you prefer day, evening, or night shifts.
                        </p>
                        <p>
                            The demand for Telemetry Technicians is high, and hospitals and healthcare facilities across the nation are hiring!
                        </p>
                    </div>

                    <h3 style={{
                        fontSize: '2.5rem',
                        textAlign: 'center',
                        marginBottom: '3rem',
                        color: '#34a8a8'
                    }}>
                        📘 What You'll Learn
                    </h3>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '2rem',
                        marginBottom: '4rem'
                    }}>
                        {[
                            {
                                icon: '🫀',
                                title: 'Cardiac Anatomy & Physiology',
                                description: 'Deep understanding of the heart\'s mechanical and electrical systems'
                            },
                            {
                                icon: '🩺',
                                title: 'EKG/ECG Machine Operation',
                                description: 'Hands-on training with professional cardiac monitoring equipment'
                            },
                            {
                                icon: '💡',
                                title: 'How to Read & Measure Rhythm Strips',
                                description: 'Master the art of interpreting cardiac rhythms with confidence'
                            },
                            {
                                icon: '🔎',
                                title: 'Common Arrhythmias & Cardiac Disorders',
                                description: 'Identify and understand various heart rhythm abnormalities'
                            },
                            {
                                icon: '📊',
                                title: 'Real-World Case Practice',
                                description: 'Apply your knowledge with actual patient scenarios and case studies'
                            }
                        ].map((feature, index) => (
                            <div key={index} style={{
                                background: 'rgba(240, 240, 240, 0.5)',
                                padding: '2rem',
                                borderRadius: '15px',
                                textAlign: 'center',
                                border: '1px solid rgba(255, 255, 255, 0.2)'
                            }}>
                                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>
                                    {feature.icon}
                                </div>
                                <h4 style={{
                                    fontSize: '1.3rem',
                                    marginBottom: '1rem',
                                    color: '#34a8a8'
                                }}>
                                    {feature.title}
                                </h4>
                                <p style={{ lineHeight: '1.6', opacity: 0.9 }}>
                                    {feature.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Course Features Section */}
            <section style={{ padding: '4rem 0' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <h3 style={{
                        fontSize: '2.5rem',
                        textAlign: 'center',
                        marginBottom: '3rem',
                        color: '#34a8a8'
                    }}>
                        ✅ Course Features
                    </h3>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '2rem'
                    }}>
                        {[
                            {
                                icon: '⏰',
                                title: 'Self-Paced Modules',
                                description: 'Learn anytime, anywhere at your own speed'
                            },
                            {
                                icon: '💻',
                                title: 'Live Zoom Sessions',
                                description: 'Weekly interactive classes with expert instructors'
                            },
                            {
                                icon: '🏅',
                                title: 'Certificate of Completion',
                                description: 'Recognized certification for your professional portfolio'
                            },
                            {
                                icon: '🔒',
                                title: 'Lifetime Access',
                                description: 'Access course content forever with unlimited reviews'
                            }
                        ].map((feature, index) => (
                            <div key={index} style={{
                                background: 'rgba(240, 240, 240, 0.5)',
                                padding: '2rem',
                                borderRadius: '15px',
                                textAlign: 'center',
                                border: '1px solid rgba(255, 255, 255, 0.2)'
                            }}>
                                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>
                                    {feature.icon}
                                </div>
                                <h4 style={{
                                    fontSize: '1.3rem',
                                    marginBottom: '1rem',
                                    color: '#34a8a8'
                                }}>
                                    {feature.title}
                                </h4>
                                <p style={{ lineHeight: '1.6', opacity: 0.9 }}>
                                    {feature.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section style={{ padding: '4rem 0', background: 'transparent' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <h3 style={{
                        fontSize: '2.5rem',
                        textAlign: 'center',
                        marginBottom: '3rem',
                        color: '#34a8a8'
                    }}>
                        💬 Questions? We've Got Answers.
                    </h3>
                    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                        {[
                            {
                                question: "How long is the course?",
                                answer: "It's self-paced and can be completed in as little as 2–4 weeks."
                            },
                            {
                                question: "Do I need prior healthcare experience?",
                                answer: "Nope! This course is beginner-friendly."
                            },
                            {
                                question: "Is the certificate valid?",
                                answer: "Yes, it's recognized by healthcare employers across the U.S."
                            }
                        ].map((faq, index) => (
                            <div key={index} style={{
                                background: 'rgba(240, 240, 240, 0.5)',
                                padding: '2rem',
                                marginBottom: '1rem',
                                borderRadius: '15px',
                                border: '1px solid rgba(255, 255, 255, 0.2)'
                            }}>
                                <h4 style={{
                                    color: '#34a8a8',
                                    marginBottom: '1rem',
                                    fontSize: '1.2rem'
                                }}>
                                    • {faq.question}
                                </h4>
                                <p style={{
                                    margin: 0,
                                    lineHeight: '1.6',
                                    opacity: 0.9,
                                    fontSize: '1.1rem'
                                }}>
                                    → {faq.answer}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Final CTA */}
            <section style={{
                padding: '4rem 0',
                background: 'linear-gradient(135deg, #34a8a8, #4a306d)',
                textAlign: 'center'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <h3 style={{
                        fontSize: '2.5rem',
                        marginBottom: '1rem',
                        color: 'white'
                    }}>
                        🔥 Enroll Today — Save $40!
                    </h3>
                    <p style={{
                        fontSize: '1.2rem',
                        marginBottom: '2rem',
                        opacity: 0.95,
                        color: 'white'
                    }}>
                        Normally $99 — now only $59.99 for the next 30 days!
                    </p>
                    <a
                        href="https://www.tdlcoaching.com/challenge-page/cd98d7e4-58c6-4ed8-83f0-2987b1dccaa5?programId=cd98d7e4-58c6-4ed8-83f0-2987b1dccaa5"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            background: 'white',
                            color: '#4a306d',
                            padding: '1.5rem 3rem',
                            textDecoration: 'none',
                            borderRadius: '50px',
                            fontSize: '1.3rem',
                            fontWeight: 'bold',
                            display: 'inline-block',
                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
                            transition: 'all 0.3s ease',
                            marginBottom: '1rem'
                        }}
                    >
                        ➡️ Get Started Now
                    </a>
                </div>
            </section>


        </div>
    );
};

export default TelemetryPage;